import ApiService from "@/services/api.service"

export const WhatsappService = {
  getStatus(superadmin = false) {
    return ApiService.get(`${superadmin ? 'superadmin/' : ''}radist/status`)
  },
  getWazzupStatus(superadmin = false) {
    return ApiService.get(`${superadmin ? 'superadmin/' : ''}wazzup/status`)
  },
  getWazzupChannels(superadmin = false) {
    return ApiService.get(`${superadmin ? 'superadmin/' : ''}wazzup/channels`)
  },
  getJetAPIStatus(superadmin = false, clinic_id = '') {
    return ApiService.get(`${superadmin ? 'superadmin/' : ''}jetapi/status?clinic_id=${clinic_id}`)
  },
  getJetAPIStatusDetailed(superadmin = false, clinic_id = '', branch_id = '') {
    return ApiService.get(`${superadmin ? 'superadmin/' : ''}jetapi/status/detailed?clinic_id=${clinic_id}&branch_id=${branch_id}`)
  },
  getJetAPIMaxStatus(superadmin = false, clinic_id = '') {
    return ApiService.get(`${superadmin ? 'superadmin/' : ''}jetapi/status/max?clinic_id=${clinic_id}`)
  },
  createJetAPIInstance(superadmin = false, params, clinic_id = '', branch_id = '') {
    return ApiService.post(`${superadmin ? 'superadmin/' : ''}jetapi/instance?clinic_id=${clinic_id}&branch_id=${branch_id}`, params)
  },
  breakJetAPIConnection(superadmin = false, clinic_id = '') {
    return ApiService.post(`${superadmin ? 'superadmin/' : ''}jetapi/instance/break?clinic_id=${clinic_id}`)
  },
  getJetApiIFrameLink() {
    return ApiService.post(`jetapi/iframe`)
  },
  authorizeJETAPIMaxInstanceSendSMS(superadmin = false, clinic_id = '', branchId = '', params) {
    return ApiService.post(`${superadmin ? 'superadmin/' : ''}jetapi/instance/max/authorize/sms/send?clinic_id=${clinic_id}&branchId=${branchId}`, params)
  },
  authorizeJETAPIMaxInstanceCheckSMS(superadmin = false, clinic_id = '', branchId = '', params) {
    return ApiService.post(`${superadmin ? 'superadmin/' : ''}jetapi/instance/max/authorize/sms/check?clinic_id=${clinic_id}&branchId=${branchId}`, params)
  },
  resetJETAPIMaxInstance(superadmin = false, clinic_id = '', branchId = '', params) {
    return ApiService.post(`${superadmin ? 'superadmin/' : ''}jetapi/instance/max/authorize/reset?clinic_id=${clinic_id}&branchId=${branchId}`, params)
  },
  getWazzupSocketCredentials() {
    return ApiService.get(`wazzup/socket`, {}, {loader: false})
  },
  createIframe(user_id = null, type = 'whatsapp') {
    return ApiService.post(`wazzup/iframe`, { user_id, type })
  },
  takeover() {
    return ApiService.post(`radist/takeover`)
  },
  getGreenAPIStatus(superadmin = false, clinic_id = '', branchId = '', loader = true, type = 'whatsapp') {
    return ApiService.get(`${superadmin ? 'superadmin/' : ''}greenapi/status?clinic_id=${clinic_id}&branchId=${branchId}&type=${type}`, {}, { loader })
  },
  createGreenAPIInstance(superadmin = false, clinic_id = '', branchId = '', type = 'whatsapp') {
    return ApiService.post(`${superadmin ? 'superadmin/' : ''}greenapi/instance?clinic_id=${clinic_id}&branchId=${branchId}&type=${type}`)
  },
  authorizeGreenAPIMaxInstanceSendSMS(superadmin = false, clinic_id = '', branchId = '', params) {
    return ApiService.post(`${superadmin ? 'superadmin/' : ''}greenapi/instance/max/authorize/sms/send?clinic_id=${clinic_id}&branchId=${branchId}`, params)
  },
  authorizeGreenAPIMaxInstanceCheckSMS(superadmin = false, clinic_id = '', branchId = '', params) {
    return ApiService.post(`${superadmin ? 'superadmin/' : ''}greenapi/instance/max/authorize/sms/check?clinic_id=${clinic_id}&branchId=${branchId}`, params)
  },
  authorizeGreenAPIMaxInstanceCheckPassword(superadmin = false, clinic_id = '', branchId = '', params) {
    return ApiService.post(`${superadmin ? 'superadmin/' : ''}greenapi/instance/max/authorize/password/check?clinic_id=${clinic_id}&branchId=${branchId}`, params)
  },
  getGreenAPIQRCode(superadmin = false, clinic_id = '', branchId = '', type = 'whatsapp') {
    return ApiService.get(`${superadmin ? 'superadmin/' : ''}greenapi/qrcode?clinic_id=${clinic_id}&branchId=${branchId}&type=${type}`, {}, { loader: false })
  },
  logoutFromGreenAPIInstance(superadmin = false, clinic_id = '', branchId = '', type = 'whatsapp') {
    return ApiService.post(`${superadmin ? 'superadmin/' : ''}greenapi/logout?clinic_id=${clinic_id}&branchId=${branchId}&type=${type}`)
  },
  deleteGreenAPIInstance(superadmin = false, clinic_id = '', branchId = '', type = 'whatsapp', force = false) {
    return ApiService.delete(`${superadmin ? 'superadmin/' : ''}greenapi/delete?clinic_id=${clinic_id}&branchId=${branchId}&type=${type}${force ? '&force=1' : ''}`)
  },
  getAivaStatus(superadmin = false, clinic_id = '', branch_id = '') {
    return ApiService.get(`${superadmin ? 'superadmin/' : ''}aiva/status?clinic_id=${clinic_id}&branch_id=${branch_id}`)
  },
  getAivaConfig(superadmin = false, clinic_id = '') {
    return ApiService.get(`${superadmin ? 'superadmin/' : ''}aiva/config?clinic_id=${clinic_id}`, {}, { loader: false })
  },
  connectAiva(superadmin = false, clinic_id = '', branch_id = '', params) {
    return ApiService.post(`${superadmin ? 'superadmin/' : ''}aiva/connect?clinic_id=${clinic_id}&branch_id=${branch_id}`, params)
  },
  disconnectAiva(superadmin = false, clinic_id = '', branch_id = '') {
    return ApiService.post(`${superadmin ? 'superadmin/' : ''}aiva/disconnect?clinic_id=${clinic_id}&branch_id=${branch_id}`)
  },
  useAivaBranch(superadmin = false, clinic_id = '', branch_id = '', source_branch_id = null) {
    return ApiService.post(`${superadmin ? 'superadmin/' : ''}aiva/use-branch?clinic_id=${clinic_id}&branch_id=${branch_id}`, { source_branch_id })
  },
  syncAivaTemplates(superadmin = false, clinic_id = '', branch_id = '') {
    return ApiService.post(`${superadmin ? 'superadmin/' : ''}aiva/templates/sync?clinic_id=${clinic_id}&branch_id=${branch_id}`)
  },
}
